import React from 'react';
import {Datagrid, DateField, List, Pagination, TextField, useTranslate} from 'react-admin';
import {ProductFilter} from "./d4prod_filter";

const ProductPagination = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100]}/>;

export const ProductList = () => {
    const translate = useTranslate();

    return (
        <List
            empty={false}
            filters={<ProductFilter/>}
            sort={{field: 'modified', order: 'DESC'}}
            exporter={false}
            pagination={<ProductPagination/>}>
            <Datagrid rowClick="show"
                      bulkActionButtons={false}>
                <TextField
                    label={translate('resources.products.fields.name')}
                    source="objName"
                />
                <TextField
                    label={translate('resources.products.fields.type.one')}
                    source="objType"
                />
                <TextField
                    label={translate('resources.products.fields.scope.one')}
                    source="objScope"
                />
                <DateField
                    label={translate('resources.products.fields.created')}
                    source="created"
                    showTime
                />
                <DateField
                    label={translate('resources.products.fields.modified')}
                    source="modified"
                    showTime
                />
            </Datagrid>
        </List>
    );
};
